import axios, { AxiosResponse, AxiosError } from 'axios';

import { remountApp } from '..';

export const attachTokenToHeader = (token: string) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const detachTokenFromHeader = () => {
  delete axios.defaults.headers.common.Authorization;
};

export const setUpAxiosInterceptors = () => {
  const onFulfilled = (response: AxiosResponse) => {
    return response;
  };

  const onRejected = (error: AxiosError) => {
    // Canceled requests have no response; reject with the original error so axios.isCancel works in callers
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.message === 'Network Error') {
      return;
    }

    const response = error.response;

    if (response && response.data.errorCode === 1) {
      localStorage.removeItem('token');
      remountApp();
    }

    return Promise.reject(response);
  };

  axios.interceptors.response.use(onFulfilled, onRejected);
};
